import { z } from 'zod'
import { useZodForm } from '@minetrace/ui/forms'

// Alta de persona nueva (conductor) cuando el DNI/CE no existe en BD.
// Mismo estándar que el resto de formularios del proyecto: schema Zod en su
// propio archivo + `useZodForm` (RHF con validación onBlur). Los mensajes son
// claves i18n que se resuelven con `t()` al pintar el error de cada campo.
export const driverPersonSchema = z.object({
  names: z.string().min(1, 'transportistas.nuevo.driverExtras.namesRequired'),
  paternalSurname: z.string().min(1, 'transportistas.nuevo.driverExtras.paternalRequired'),
  maternalSurname: z.string().optional(),
  email: z
    .string()
    .min(1, 'transportistas.nuevo.driverExtras.emailRequired')
    .email('transportistas.nuevo.driverExtras.emailInvalid'),
  phoneMobile: z.string().min(1, 'transportistas.nuevo.driverExtras.phoneRequired'),
})

export type DriverPersonFormValues = z.infer<typeof driverPersonSchema>

export const driverPersonDefaults: DriverPersonFormValues = {
  names: '',
  paternalSurname: '',
  maternalSurname: '',
  email: '',
  phoneMobile: '',
}

export const useDriverPersonForm = (props?: { defaultValues?: DriverPersonFormValues; disabled?: boolean }) =>
  useZodForm<DriverPersonFormValues>({
    validationSchema: driverPersonSchema,
    defaultValues: { ...driverPersonDefaults, ...props?.defaultValues },
    disabled: props?.disabled,
  })
